import styled from '@emotion/styled'

export const Main = styled.div((props) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  height: 'auto',

  '.header':{
    display:'flxe',
    alignItems:'center',
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    background: '#EAEFF5',
    padding: 12,
    fontFamily: 'IBM Plex Sans Thai',
    fontSize: '1.25rem',
    fontWeight: 'bold',
    justifyContent:'space-between'
  },

  '.content':{
    fontSize:'1rem',
    padding:12,
    background:'#fff',
    borderBottomLeftRadius:5,
    borderBottomRightRadius:5
  }
}))
